"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const react_1 = require("react");
const get_value_1 = __importDefault(require("../utils/get-value"));
function useInputDebounce({ value, onChange, wait = 400, debounceOptions, }) {
    const upstreamValue = (0, react_1.useRef)(value);
    const [inputValue, setInputValue] = (0, react_1.useState)(value);
    const deOnChange = (0, react_1.useCallback)((0, lodash_debounce_1.default)((val, normalizer) => {
        onChange(val, normalizer);
        upstreamValue.current = normalizer ? normalizer(val) : val;
    }, wait, debounceOptions), [wait, debounceOptions]);
    (0, react_1.useEffect)(() => {
        if (upstreamValue.current !== value && value !== inputValue) {
            deOnChange.cancel();
            upstreamValue.current = value;
            setInputValue(value);
        }
    }, [value]);
    return [
        inputValue,
        (e, normalizer) => {
            const val = (0, get_value_1.default)(e);
            setInputValue(normalizer ? normalizer(val) : val);
            deOnChange(val, normalizer);
        },
        deOnChange.flush,
    ];
}
exports.default = useInputDebounce;
//# sourceMappingURL=useInputDebounce.js.map